import { render, staticRenderFns } from "./json-editor.component.vue?vue&type=template&id=f9860e1c&scoped=true"
import script from "./json-editor.component.vue?vue&type=script&lang=ts"
export * from "./json-editor.component.vue?vue&type=script&lang=ts"
import style0 from "./json-editor.component.vue?vue&type=style&index=0&id=f9860e1c&prod&lang=scss&scoped=true"
import style1 from "./json-editor.component.vue?vue&type=style&index=1&id=f9860e1c&prod&lang=scss&global=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9860e1c",
  null
  
)

export default component.exports